import app from './app';

const settings = {
  run: async () => {
    const response = await fetch(`/api/settings?i18n=${app.run.i18n}`, {headers: app.run.headers});
    const json = await response.json();

    app.run.settings = json.settings;
    app.lib.token.set(json._token);
  },
};

export default settings;
